module.exports = __webpack_public_path__ + "img/bannercursos.abc00c59.jpg";